<template>
    <el-table :data="logs" border highlight-current-row class="table">
        <el-table-column prop="createDate" :label="$t('common.OperationTime') ">
            <template slot-scope="scope">
                {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}
            </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="operatorName" :label="$t('common.OperatorName') "></el-table-column>
        <el-table-column show-overflow-tooltip prop="action" :label="$t('common.PedagogicalOperation') "></el-table-column>
        <el-table-column show-overflow-tooltip prop="comments" :label="$t('common.opinion') "></el-table-column>
    </el-table>
</template>

<script>
    export default {
        name: "workflowLogTable",
        props:{
            logs: Array
        }
    }
</script>

<style scoped>

</style>
